export enum PROCESS_STATUS {
	None = 0,
	Started = 10,
	FinishedAML = 11,
	FinishedAppropriateness = 12,
	FinishedSuitability = 13,
	SelectedRiskProfile = 14,
	FinishedNetbanki = 15,
	FinishedMandate = 16,
	FinishedInterests = 17,
	FinishedMembers = 18,
	AddedDerivativesProduct = 19,
	InSigning = 20,
	PrintedContractForManualSigning = 21,
	InProcessing = 30,
	Finished = 40,
	Canceled = 50,
	Expired = 60
}

export const PROCESS_STATUS_LIST = Object.keys(PROCESS_STATUS).filter(
	x => !Number.isInteger(+x)
) as (keyof typeof PROCESS_STATUS)[];
